<template>
  <div >
 <h2 >Home/Dashboard</h2>
        <div class="card row m-2">
            <div class="col-lg-11 col-11 mx-auto">
            <div class="embed-responsive embed-responsive-16by9">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/0EpU4uwO4NI" title="YouTube video player"
            frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
            </div>
        </div>

<!-- <div class="habit-card-sub-body d-flex mx-auto" > -->
        <div class="card text-center bg-secondary">
            In more than one way, Life is a Game.  A game we want to win.<br/>
 Each one of us seeks "Success in my Older years: Version 2.0 of Me.
            <br/>Powerful, Empowered, Capable, Independent, Fearless, Feisty, Funxx."

<br/><h4>Get into the Game.  Play to win. <br/> (The tools here put you ahead of the 95% of the crowd.)</h4>
            </div>
<hr/>
            <div class="row">


            <div class="col-lg-12 col-12 card row mx-auto"><h4 style="margin:auto;color:#55060e;">Your Performance Winnings display:</h4><br/>
            <img style="max-width: 100%; width:360px;margin:auto;" src="/assets/content/AwardsCeremony.png"/></div>
                <!-- <div class="color-palette-set bordered m-2 p-4">
                  <div class="bg-primary color-palette px-1"><span>Designing My Future</span> <i class="far fa-calendar-alt"></i></div>
                  <div class="bg-primary disabled color-palette px-1"><span> <button class="btn btn-sm fai-blue bg-light mb-2" @click="showVideo">The Why and How&nbsp;<i class="fa fa-tv fai-blue"></i></button></span></div>
                </div> -->
                <!-- <div class="color-palette-set  bordered  m-2 p-4">
                  <div class="bg-warning color-palette px-1"><span>Design/Review my Future-Self Strategy</span> <i class="fas fa-exchange-alt"></i></div>
                    <div class="bg-warning disabled color-palette px-1"><span>
                        <button class="btn btn-sm bg-light mb-2" @click="defineMyFS">Design/Review my Future-Self Strategy &amp; Plan &nbsp;<i class="fas fa-plus fai-green"></i>
                        </button></span>
                    </div>
                </div> -->
                <!-- <div v-if="myfsdata && myfsdata.length>0" class="color-palette-set  bordered  m-2 p-4">
                  <div class="bg-info color-palette px-1"><span>Report today's Performance</span> <i class="far fa-calendar-alt"></i></div>
                  <div class="bg-info disabled color-palette px-1"><span><button class="btn btn-sm fai-blue bg-light mb-2" @click="reportMyPerformance">Track/Report my Performance&nbsp;<i class="fa fa-pen fai-orange"></i></button></span></div>
                </div>
                <div  v-if="myfsdata && myfsdata.length>0" class="color-palette-set  bordered  m-2 p-4">
                  <div class="bg-success color-palette px-1"><span>View my Performance Results</span> <i class="fas fa-retweet"></i></div>
                  <div class="bg-success disabled color-palette px-1"><span><button class="btn btn-sm fai-blue bg-light mb-2" @click="viewMyPerformance">View my Performance Results&nbsp;<i class="fas fa-chart-area fai-blue"></i></button></span></div>
                </div> -->
            </div>

          </div>
        <!-- </div> -->

</template>

<script>

import axios from 'axios';
import Errors from '../partials/Errors.vue';
import Swal from 'sweetalert2';
var _ = require('lodash');
import EventBus from '../../event-bus';
import { v4 as uuidv4 } from 'uuid';

export default {
    components: { Errors },
    name: "SiteDashboard",
    data() {
        return {
            userdata:[],
           myfsdata:[],
            errors: {
                        nahme: '',
                        message: '',
                    },
            showVideoName:'designing_your_futureself_why_how',
            videoData:'',
        }
    },
    props: {
        user:'',
        myfsdetails:'',
        videolinks:''
    },
    mounted() {

    },

    methods: {
        // defineMyFS(){
        //     window.location.replace('/fself/create');
        // },
        showVideo(){
            console.error('MyFSDashboard.....');
            var videourl = this.extractVideoURL(this.showVideoName);
            console.log('videourl extracted: ' + videourl);
            const payload = {title:'The Importance of (Your) FutureSelf', videourl: videourl};//'https://player.vimeo.com/video/626019659?h=fb5c62f51f'};
            EventBus.$emit('displayVideoModal', payload);
        },
        // reportMyPerformance(){
        //     window.location.replace('/fself/view');
        // },
        // viewMyPerformance(){
        //     window.location.replace('/fself/reports');
        // },
        // extractVideoURL(videokey) {
        //     var videoURL = '';
        //    for (const [key, value] of Object.entries(this.videoData)) {
        //         if(key == videokey) {
        //             videoURL= value;
        //         }
        //     }
        //     return videoURL;
        // }

    }


}
</script>

<style scoped>
.habit-page {
  -ms-flex-align: center;
  align-items: center;
  background: #e9ecef;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100vh;
  -ms-flex-pack: center;
  justify-content: center;
}
.habit-box {
  width: 540px;

}

.habit-card-body {
  background: #eee;
  border-top: 0;
  color: #666;
  padding: 20px;
}
.habit-card-sub-body {
    width:80%;
    border:1.5px solid #fff;
    background: rgb(230, 234, 247);
    border-top: 1em;
    margin: 4.4em;
    color: #666;
    padding: 20px;
    border-radius:4px;/*2em 2em 0em 0em;*/
    box-shadow: #ddd 4px 4px 4px;
}
.input-group{
margin-bottom:.4em;
}

.btn-container{
display:flex;
margin:1em;
}
a, button {
margin-left:auto;
}
.div-box{
margin: 2em;
padding: 2em;
border: solid 1px #fff;
box-shadow: 4px 4px 4px #666;
 border-radius:2em 2em 0em 0em;
}
.customElements{
margin: 2em;
padding: 2em;
border: solid  1px #fff;
border-radius:2em 2em 0em 0em;
box-shadow: 4px 4px 4px #666;
}
.header-box-msg, .habit-table-head{
padding:.75em;
background:#343a40;
color:#ffc107;
}
.tracker-btn{
    margin-top: .5em;
    margin-bottom: .5em;
    margin-left:1em;
    /* margin-right:1em; */
    width:80%;
    padding: .5em;
    /* align-content: center; */
}
.fai-red{
    color:rgb(129, 67, 67);
}
.fai-green{
    color:rgb(65, 131, 65);
}
.fai-blue{
    color:rgb(18, 7, 240);
}
.fai-orange{
    color:rgb(230, 111, 13);
}





.mobile-first,
.desktop-first {
  padding: 1em;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.15);
  margin: 2em auto;
  max-width: 750px;
}

/*  mobile-first */
@media (min-width: 600px) {
  .mobile-first .sales-points {
    display: flex;
    justify-content: space-between;
  }

  .mobile-first .sales-point {
    width: 30%;
  }
}

/* desktop first */
.desktop-first .sales-points {
  display: flex;
  justify-content: space-between;
}

.desktop-first .sales-point {
  width: 30%;
}

@media (max-width: 600px) {
  .desktop-first .sales-points {
    display: block;
  }

  .desktop-first .sales-point {
    width: 100%;
  }
}
.bordered{
border: .5px solid rgb(193, 191, 191);
border-radius: 4px;
padding: 82px;
margin: 2px;
background: #d9e7f4;
}





</style>
